import {Component, EventEmitter, Input, Output} from '@angular/core';

import {
  EmpresaTableColumn,
  EmpresaTableParams
} from '../../../models';

import {TableActionEvent, TableParams, TableRow} from '../../../../shared';
import {EMPRESA_TABLE_COLUMNS_DEFAULT} from "../../../constants";
import {createEmpresaTableRow} from "../../../helpers";

@Component({
  selector: 'app-empresa-table',
  templateUrl: './empresa-table.component.html',
  styleUrls: ['./empresa-table.component.scss']
})
export class EmpresaTableComponent {
  // aux
  columns: EmpresaTableColumn[] = [];
  rows: TableRow[] = [];
  // output
  @Output() actioned = new EventEmitter<TableActionEvent>();
  tableParams: TableParams = {
    columns: [],
    values: []
  };
  // search outside
  @Input() filterText: string = null;

  constructor() {
  }

  // input
  private _params: EmpresaTableParams = null;

  get params(): EmpresaTableParams {
    return this._params;
  }

  @Input()
  set params(params: EmpresaTableParams) {
    this._params = params;
    this.update();
  }

  update() {
    this.columns = [];
    this.columns = this.params.columns || EMPRESA_TABLE_COLUMNS_DEFAULT;
    this.updateRows();
    this.tableParams = {
      columns: this.columns.map(c => ({...c})),
      values: this.rows.map(r => ({...r})),
      filter: this.params.filter,
      pagination: this.params.pagination
    };
  }

  // datasource

  updateRows() {
    const rows: TableRow[] = [];
    for (const p of this.params.empresas) {
      rows.push(createEmpresaTableRow(p, this.columns, this.params.sources));
    }
    this.rows = rows;
  }

  emit(action: TableActionEvent) {
    this.actioned.emit(action);
  }
}
